<!-- 选择单元组件 -->
<template>
  <div class="cascad-menu-box" ref="cascadMenu" >
    <div class="header df-between" id='header' :style="{'padding-top':utils.isIphoneX()?'50px':'30px'}">
      <img src="../../assets/images/i-arrow-left.png" @click='handleBack' alt="" >
      <div class="title">{{pageTitle}}</div>
      <span class='addWard' @click='handleAddWard'>添加单元</span>
    </div>
    <div class="introduce-box" v-if='isShowIntroduce' :style="{'top':utils.isIphoneX()?'85px':'65px'}">
      添加病区/科室等最小物理督导单元
      <span class='sanjiao'></span>
      <div class='deptTips-close-box' @click='handleCloseIntroduce'>
        <img src="../../assets/images/deptTips-close.png" alt="">
      </div>
    </div>
    <div class="tag-box" id='tagBox' v-if='searchRecordData.length>0' :style='{"padding":searchRecordData.length>0?"15px 12px 5px 12px":"0px 12px"}' >
      <div class="tag-item df-center" v-for='(item,index) in searchRecordData' :key='index' v-if='item.isShowTag'>
        {{item.name}}
        <div class="img-box" @click="handleCloseTag(index)">
           <img src="../../assets/images/tag-close.png" alt="">
        </div>
      </div>
    </div>
    <div class="search-box" id='searchBox' :style='{"padding-top":searchRecordData.length>0?"0px":"15px"}' @click='handleSearch' >
      <img src="../../assets/images/iv_search.png" alt="" >
      <input type="text" disabled placeholder="输入关键字搜索" style="pointer-events: none;">
    </div>
    <div class="tab-box" id='tabBox'>
      <div :style='{"padding-left":deptData.length<3?"15px":"0px"}'>
        <van-tabs
          v-model="tabIndex"
          color='#26B4FF'
          :ellipsis="false"
          title-active-color='#26B4FF'
          title-inactive-color='#333'
          @click='handleChangeTab'
        >
          <van-tab
            v-for="(item,index) in deptData"
            :title="item.name"
            :key='index'
             title-style='font-size:16px;height:48px;'
          >
          </van-tab>
        </van-tabs>
      </div>
      <span
        class='ward-num'
        style='width: 45%;height:48px;'
        @click='handleYetSelect'
        v-show='totalWardNumber.length>0'
      >查看已选{{totalWardNumber.length}}个单元</span>
    </div>
    <div
      v-if='deptData.length>0'
      class="cascad-menu"
      :style='{"top":cascadMenuTop,"height":cascadMenuHeight}'
    >
      <scroll
        class="left-menu"
        :data="deptData[tabIndex].children"
        ref="leftMenu"
      >
        <div class="left-menu-container">
          <ul>
            <li
              class="left-item df-center"
              ref="leftItem"
              :class="{'current': curIndex === index}"
              @click="selectLeft(index, $event)"
              v-for="(item, index) in deptData[tabIndex].children"
              :key="index"
            >
              <p class="text">{{item.name}}</p>
            </li>
          </ul>
        </div>
      </scroll>
      <scroll
        class="right-menu"
        :data="deptData[tabIndex].children"
        ref="rightMenu"
        @scroll="scrollHeight"
        :listenScroll="true"
        :probeType="3"
      >
        <div class="right-menu-container">
          <ul>
            <li
              class="right-item"
              ref="rightItem"
              v-for="(item1, index1) in deptData[tabIndex].children"
              :key="index1"
            >
              <div class="title">
                <span>{{item1.name}}</span>
                <div class="item-checkall">
                  <span class='all-text'>全部</span>
                  <van-checkbox
                    v-model="item1.isSelect"
                    :disabled='(comeFrom!="conFirmReportDept"&&item1.isDefault==1)||reportStatus=="1"?true:totalWardNumber.length>relevanceNumber-1&&item1.isSelected=="0"?true:false'
                    @click="changeItemBox(index1,item1.isDefault)"
                  >
                    <template #icon="props">
                      <img
                        style='width:15px;height:15px;'
                        :src="props.checked ? activeIcon : inactiveIcon"
                      />
                    </template>
                  </van-checkbox>
                </div>

              </div>
              <ul>
                <li
                  v-for="(item2, index2) in item1.children"
                  :key="index2"
                >
                  <div
                    v-for="(item3, index3) in item2.wards"
                    :key="index3"
                  >
                    <div class="data-wrapper">
                      <div class="data">{{item3.inpatientArea}}-{{item2.name}}</div>
                      <van-checkbox-group
                        @change="changeGroupBox"
                        v-model="item1.groupResult"
                        ref="checkboxGroup"
                      >
                        <van-checkbox
                          @click="changeBox(index1,index2,index3,item3.isSelected,item3.isDefault,item3.itemIndex)"
                          icon-size="20px"
                          :disabled='(comeFrom!="conFirmReportDept"&&item3.isDefault==1)||reportStatus=="1"?true:totalWardNumber.length>relevanceNumber-1&&item3.isSelected=="0"?true:item3.itemIndex&&item3.itemIndex!=(currentIndex+1)?true:false'
                          :name="item3.id"
                        >
                          <template #icon="props">
                            <img
                              style='width:15px;height:15px;'
                              :src="props.checked ? activeIcon :(comeFrom!='conFirmReportDept'&&item3.isDefault==1)||reportStatus=='1' || totalWardNumber.length>relevanceNumber-1&&item3.isSelected=='0' || item3.itemIndex&&item3.itemIndex!=(currentIndex+1)?inactiveIconDisabled:inactiveIcon"
                            />
                          </template>
                        </van-checkbox>
                      </van-checkbox-group>
                    </div>
                  </div>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </scroll>
    </div>
    <!-- <div class="tips-box df-between" v-if='isShowCloseTips'>
      <div class="tips-left">
        <img class='dept-notice' src="../../assets/images/dept-notice.png" alt="">
        <span>红色为已禁用单元</span>
      </div>
      <img class='dept-close' @click='handleCloseTips' src="../../assets/images/dept-close.png" alt="">
    </div> -->
    <div class="button-box" id='buttonBox' v-if='reportStatus=="0"'>
      <div class="btn reset df-center" @click='handleReset' >重置</div>
      <div class="btn confirm df-center" @click='handleconfirm' >确定</div>
    </div>

    <yd-popup v-model="isShowSearchWardPage" position="right" width="100%" >
      <searchWard ref='searchWard' :totalWardNumber='totalWardNumber' :relevanceNumber='relevanceNumber' v-on:handlleCloseSearchWard='handlleCloseSearchWard' v-on:conFirmSearchDept='conFirmSearchDept' :deptData='deptData' :tabIndex='tabIndex' ></searchWard>
    </yd-popup>
    <yd-popup v-model="isShowYetSelectWardPage" position="right" width="100%" >
      <yetSelectWard v-on:handlleCloseYetSelectWard='handlleCloseYetSelectWard' :totalWardNumber='totalWardNumber' :yetSelectWards='yetSelectWards' v-on:delWard='delWard' :deptData='deptData' ></yetSelectWard>
    </yd-popup>
    <yd-popup v-model="isShowAddWardPage"  position="right" width="100%" >
      <addWrad v-on:handlleCloseAddWard='handlleCloseAddWard' v-on:successAddDept='successAddDept' :isShowAddWardPage='isShowAddWardPage' :secondNodeName='secondNodeName' :deptData='deptData'></addWrad>
    </yd-popup>
  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import searchWard from './searchWard'
  import yetSelectWard from './yetSelectWard'
  import addWrad from './addWrad'

  import Scroll from './scroll'
  import { Popup } from 'vue-ydui/dist/lib.rem/popup'
  Vue.component(Popup.name, Popup)
  import { Toast, Loading, Confirm } from 'vue-ydui/dist/lib.rem/dialog'
  export default {
    props:['yetSelectWards','currentIndex','totalYetSelectWards','relevanceNumber'],
    data() {
      return {
        reportStatus:'',
        cascadMenuTop:'',
        cascadMenuHeight:'',
        secondNodeId:'',//院区id
        secondNodeName:'',//院区名称
        comeFrom:'',// 根据来源判断部分逻辑
        isShowIntroduce:true,
        isShowYetSelectWardPage: false,
        isShowSearchWardPage: false,
        isShowAddWardPage: false,
        isShowCloseTips: true,
        pageTitle: '选择单元',
        totalWardNumber: [], // 所有院区已选单元id
        curIndex: 0,
        tabIndex: 0,
        deptData: [],
        activeIcon: require('../../assets/images/select11.png'),
        inactiveIcon: require('../../assets/images/select12.png'),
        inactiveIconDisabled: require('../../assets/images/select13.png'),
        rightTops: [],
        scrollY: 0,
        // searchRecordData: [
        //   {
        //     id: '1',
        //     name: '1w-的地方地方骨科',
        //     isShowTag: true,
        //   },
        //   {
        //     id: '2',
        //     name: '2w-骨科',
        //     isShowTag: true,
        //   },
        //   {
        //     id: '3',
        //     name: 'asdfaasdfasdf',
        //     isShowTag: true,
        //   }
        // ],
        searchRecordData:[]
      }
    },
    components: {
      Scroll,
      searchWard,
      yetSelectWard,
      addWrad
    },
    computed: {
      ...mapState({
          _userInfo: (state) => state.InvestorInfo,
        }
      ),
    },
    created() {
      this.reportStatus = localStorage.getItem('reportStatus')
      this.comeFrom = this.$route.query.comeFrom
      this.$nextTick(() => {
        // this._calculateHeight()
      })
      this.initWardData()
    },
    mounted() {
      let headerHeight = document.getElementById('header').offsetHeight
      let tagBoxHeight = document.getElementById('tagBox')?document.getElementById('tagBox').offsetHeight:0
      let searchBoxHeight = document.getElementById('searchBox').offsetHeight
      let tabBoxHeight = document.getElementById('tabBox').offsetHeight
      let buttonBoxHeight = document.getElementById('buttonBox')?document.getElementById('buttonBox').offsetHeight:0
      console.log(headerHeight,tagBoxHeight,searchBoxHeight,tabBoxHeight,buttonBoxHeight,'66666');
      this.cascadMenuTop = headerHeight+tagBoxHeight+searchBoxHeight+tabBoxHeight+'px'
      let otherHight = headerHeight+tagBoxHeight+searchBoxHeight+tabBoxHeight+buttonBoxHeight
      this.cascadMenuHeight = `calc(100% - ${otherHight}px)`
      console.log(this.cascadMenuHeight,'this.cascadMenuHeight');
    },
    methods: {
      handleCloseIntroduce(){
        this.isShowIntroduce = false
      },
      // 添加单元
      handleAddWard(){
        this.secondNodeId = this.deptData[this.tabIndex].id
        localStorage.setItem('secondNodeId',this.secondNodeId)
        this.secondNodeName = this.deptData[this.tabIndex].name
        this.isShowAddWardPage = true
      },
      // 显示搜索页面
      handleSearch() {
        if(this.reportStatus=='0'){
          this.isShowSearchWardPage = true
        }
      },
      // 显示已选择页面
      handleYetSelect() {
        console.log(this.deptData,'查看已选单元');
        this.isShowYetSelectWardPage = true
      },
      // 确认搜索的单元
      conFirmSearchDept(val){
        this.tabIndex = val.index
        console.log(val,'val');
        if(this.deptData[val.index].children[val.index1].children[val.index2].wards[val.index3].isSelected == '0'){
          this.deptData[val.index].children[val.index1].children[val.index2].wards[val.index3].isSelected = '1'
          this.deptData[val.index].children[val.index1].groupResult.push(val.id)
          if(this.deptData[val.index].children[val.index1].groupResult.length == this.deptData[val.index].children[val.index1].outWardData.length){
            this.deptData[val.index].children[val.index1].isSelect = true
          }
          this.handleWardNumber()
        }
        this.isShowSearchWardPage = false
        this.$refs.searchWard.handleSearchReset()
        console.log(this.deptData,'搜索后的this.deptData');
      },
      // 关闭搜索页面
      handlleCloseSearchWard() {
        this.isShowSearchWardPage = false
      },
      // 关闭已选择页面
      handlleCloseYetSelectWard() {
        this.isShowYetSelectWardPage = false
      },
      // 关闭添加单元页面
      handlleCloseAddWard(){
        this.isShowAddWardPage = false
      },
      // 成功添加了单元
      successAddDept(){
        this.initWardData()
      },
      // 删除已选择单元
      delWard(index1, index2, index3, index4, delId) {
        this.deptData[index1].children[index2].groupResult.forEach((v, i) => {
          if (v == delId) {
            this.deptData[index1].children[index2].isSelect = false
            this.deptData[index1].children[index2].groupResult.splice(i, 1)
          }
        })
        this.deptData[index1].children[index2].children[index3].wards[
          index4
        ].isSelected = '0'
        this.deptData[index1].children[index2].children[index3].wards[
          index4
        ].itemIndex = null // 去除已经其他科室选过的状态
        this.totalWardNumber.forEach((v, i) => {
          if (v == delId) {
            this.totalWardNumber.splice(i, 1)
          }
        })
        this.deptData[index1].districtWardNumber.forEach((v, i) => {
          if (v == delId) {
            this.deptData[index1].districtWardNumber.splice(i, 1)
          }
        })
        this.totalYetSelectWards.forEach((v,i)=>{ // 解决从已选单元删除单元后在次进入到列表不同index下无法选择问题
          if (v.id == delId) {
            this.totalYetSelectWards.splice(i, 1)
          }
        })
        // this.isShowYetSelectWardPage = false
        console.log(index1, 'index1')
        console.log(index2, 'index2')
        console.log(index3, 'index3')
        console.log(index4, 'index4')
        console.log(delId, 'delId')
      },
      handleChangeTab() {
        this.curIndex = 0
        this.handleAllIsClick()
      },
      // 返回
      handleBack(){
        this.$emit('sendDeptData',this.totalWardNumber)
        this.handleReset()
      },
      // 确定选择的单元
      handleconfirm() {
        this.$emit('sendDeptData',this.totalWardNumber)
        this.handleReset()
      },
      // 清空选择的单元
      handleReset() {
        this.totalWardNumber = []
        for (let i = 0; i < this.deptData[this.tabIndex].children.length; i++) {
          let item = this.deptData[this.tabIndex].children[i]
          item.groupResult = []
          item.isSelect = false
          for (let j = 0; j < item.children.length; j++) {
            for (let k = 0; k < item.children[j].wards.length; k++) {
              item.children[j].wards[k].isSelected = '0'
            }
          }
        }
        this.handleWardNumber()
        console.log(this.deptData, '重置后的deptData')
      },
      // 默认单元是否有全选 控制全选按钮是否能点击
      handleAllIsClick() {
        let flag = true
        this.deptData[this.tabIndex].children.forEach((v, i) => {
          if (v.outWardData.length == v.groupResult.length) {
            v.isSelect = true
          }
          v.children.forEach((v1, i1) => {
            v1.wards.forEach((v2, i2) => {
              if (v2.isSelected == '0') {
                flag = false
              }
              if (flag && v2.isDefault == '1') {
                v.isDefault = '1'
              }
            })
          })
        })
      },
      handleInitData(){
        this.deptData.forEach((v, i) => {
          this.$set(v, 'districtWardNumber', []) // 存储某一个院区被选中的单元
          this.$set(v, 'isFlod', true) // 控制已选单元的展开和折叠
          v.children.forEach((v1, i1) => {
            this.$set(v1, 'isDefault', '0') // 全选按钮是否默认选中
            this.$set(v1, 'isSelect', false) // 存储全选状态
            this.$set(v1, 'groupResult', []) // 存储全选项下的子项集合
            this.$set(v1, 'outWardData', [])
            this.$set(v1, 'parentItemIndex', this.currentIndex==0||this.currentIndex?this.currentIndex+1:null) // 记录是从列表的哪一项过来
            v1.children.forEach((v2, i2) => {
              v2.wards.forEach((v3, i3) => {
                this.$set(v3, 'isDefault', '0') // 子项是否默认选中
                v1.outWardData.push(v3.id) // 存储最后一个children下的每一项的wards的每一项
                if (this.yetSelectWards.length > 0) {
                  this.yetSelectWards.forEach((v4, i4) => {
                    if (v4 == v3.id) {
                      v1.groupResult.push(v3.id)
                      v3.isSelected = '1'
                      this.$set(v3, 'isDefault', '1') // 默认的单元（不可取消已选状态）
                    }
                  })
                }
                if(this.totalYetSelectWards.length>0){
                  this.totalYetSelectWards.forEach((x,y)=>{
                    if(x.id == v3.id){
                      this.$set(v3, 'itemIndex', x.index) // 记录单元已被科室选中
                    }
                  })
                }
              })
            })
          })
        })
        this.handleWardNumber()
        this.handleAllIsClick()
      },
      initWardData() {
        axios({
          method: 'post',
          timeout: 30000,
          url: 'incontrol-intf/api/dept/getWardTrees',
          data: { data: { comId: this._userInfo.data.comId } },
          headers: {
            'x-accessToken': this._userInfo.data.token,
            'x-domain': 'A0',
          },
        }).then((response) => {
          if (response.data.code == 0) {
            this.deptData = response.data.data[0].children
            this.handleInitData()
            console.log(this.deptData, '首次获取this.deptData')
          } else {
            Toast({ mes: response.data.msg, timeout: 2000 })
          }
        })
      },
      changeGroupBox(val) {},
      // 全选
      changeItemBox(index1, isDefault) {
        console.log(index1, '全选时的index')
        if (this.comeFrom!="conFirmReportDept"&&isDefault == 1) {
          Toast({ mes: '负责单元不能取消', timeout: 2000 })
          return
        }
        if(this.reportStatus=='1'){
          Toast({ mes: '数据已上报，无法修改', timeout: 2000 })
          return
        }
        let currentItem = this.deptData[this.tabIndex].children[index1]
        currentItem.groupResult = []
        for (let j = 0; j < currentItem.children.length; j++) {
          for (let k = 0; k < currentItem.children[j].wards.length; k++) {
            if (currentItem.isSelect) {
              if(currentItem.outWardData.length+this.totalWardNumber.length<this.relevanceNumber+1){ // 最多关联的单元数量
                if(currentItem.parentItemIndex!=currentItem.children[j].wards[k].itemIndex&&currentItem.children[j].wards[k].itemIndex){
                  Toast({ mes: '已关联其他标准科室的单元不会被选中', timeout: 2000 })
                }else{
                  currentItem.children[j].wards[k].isSelected = '1' // 修改数据为选中
                  currentItem.groupResult.push(currentItem.children[j].wards[k].id)
                  currentItem.children[j].wards[k].itemIndex = this.currentIndex+1
                  this.totalYetSelectWards.push({id:currentItem.children[j].wards[k].id,index:this.currentIndex+1})
                }
              }else{
                 currentItem.isSelect = false // 重置全选按钮的选择状态
                 Toast({ mes: '最多只能关联'+this.relevanceNumber+'个单元', timeout: 2000 })
              }
            } else {
              if(this.comeFrom!="conFirmReportDept"){
                if (currentItem.children[j].wards[k].isDefault == '1') {
                  currentItem.children[j].wards[k].isSelected = '1'
                  currentItem.groupResult.push(currentItem.children[j].wards[k].id)
                } else {
                  currentItem.children[j].wards[k].isSelected = '0'
                }
              }else{
                currentItem.children[j].wards[k].isSelected = '0'
                if(currentItem.parentItemIndex==currentItem.children[j].wards[k].itemIndex&&currentItem.children[j].wards[k].itemIndex){
                  currentItem.children[j].wards[k].itemIndex = null // 去除已经其他科室选过的状态
                  this.totalYetSelectWards.forEach((x,y)=>{
                    if(x.id == currentItem.children[j].wards[k].id){
                      this.totalYetSelectWards.splice(y,1)
                    }
                  })
                }
              }
            }
          }
        }
        this.handleWardNumber()
        console.log(this.totalYetSelectWards,'全选时的totalYetSelectWards');
        console.log(this.totalWardNumber, '全选时的totalWardNumber')
        console.log(this.deptData, '全选时的deptData')
      },
      // 单选
      changeBox(index1, index2, index3, isSelected, isDefault,itemIndex) {
        console.log(itemIndex,'单选时的itemIndex');
        console.log( index1, 'index1', index2, 'index2', index3, 'index3', isSelected, '当前项的选中状态' )
        if(this.reportStatus=='1'){
          Toast({ mes: '数据已上报，无法修改', timeout: 2000 })
          return
        }
        if(this.currentIndex+1!=itemIndex&&itemIndex){
          Toast({ mes: '该单元已关联其他标准科室', timeout: 2000 })
          return
        }
        if(this.totalWardNumber.length==this.relevanceNumber&&isSelected=='0'){
          Toast({ mes: '最多只能关联'+this.relevanceNumber+'个单元', timeout: 2000 })
          return
        }
        if (this.comeFrom!="conFirmReportDept"&&isDefault == 1) {
          Toast({ mes: '负责单元不能取消', timeout: 2000 })
          return
        }
        this.totalWardNumber = []
        let currentItem = this.deptData[this.tabIndex].children[index1]
        for (let j = 0; j < currentItem.children.length; j++) {
          for (let k = 0; k < currentItem.children[j].wards.length; k++) {
            if ( currentItem.groupResult.length == currentItem.outWardData.length ) {
              currentItem.isSelect = true
            } else {
              currentItem.isSelect = false
            }
            if (isSelected == '0') {
              // 点击的时候为未选中
              currentItem.children[index2].wards[index3].isSelected = '1'
              currentItem.children[index2].wards[index3].itemIndex = this.currentIndex+1
              if(k == index3 && j == index2){
                this.totalYetSelectWards.push({id:currentItem.children[index2].wards[index3].id,index:this.currentIndex+1})
              }
            } else {
              currentItem.children[index2].wards[index3].isSelected = '0'
              currentItem.children[index2].wards[index3].itemIndex = null // 去除已经其他科室选过的状态
              this.totalYetSelectWards.forEach((x,y)=>{
                if(x.id == currentItem.children[index2].wards[index3].id){
                  this.totalYetSelectWards.splice(y,1)
                }
              })
            }

          }
        }
        this.handleWardNumber()
        console.log(this.totalYetSelectWards,'单选时的totalYetSelectWards');
        console.log(this.totalWardNumber, '单选时的totalWardNumber')
        console.log(this.deptData, '单选时的deptData')
      },
      // 处理选择的单元数量
      handleWardNumber() {
        this.totalWardNumber = []
        for (let i = 0; i < this.deptData.length; i++) {
          this.deptData[i].districtWardNumber = []
          for (let j = 0; j < this.deptData[i].children.length; j++) {
            for ( let k = 0; k < this.deptData[i].children[j].groupResult.length; k++ ) {
              this.deptData[i].districtWardNumber.push( this.deptData[i].children[j].groupResult[k] )
              this.totalWardNumber.push( this.deptData[i].children[j].groupResult[k] )
            }
          }
        }
      },
      selectLeft(index, event) {
        this.curIndex = index
        console.log(index)
        if (!event._constructed) {
          return
        }
        let rightItem = this.$refs.rightItem
        let el = rightItem[index]
        this.$refs.rightMenu.scrollToElement(el, 300)
      },
      scrollHeight(pos) {
        console.log(pos)
        this.scrollY = Math.abs(Math.round(pos.y))
      },
      _calculateHeight() {
        let lis = this.$refs.rightItem
        let height = 0
        this.rightTops.push(height)
        Array.prototype.slice.call(lis).forEach((li) => {
          height += li.clientHeight
          this.rightTops.push(height)
        })
        console.log(this.rightTops)
      },
      handleCloseTips() {
        this.isShowCloseTips = false
      },
      handleCloseTag(index) {
        console.log(index,'index');
        this.searchRecordData[index].isShowTag = false
        this.searchRecordData.splice(index, 1)
      },
    },
    watch: {
      yetSelectWards(){
        console.log(this.yetSelectWards,'子组件的yetSelectWards');
        this.handleInitData()
        console.log(this.deptData,'从列表进来修改后的deptData');
      }
    },
  }
</script>
<style lang='scss'>
  .item-checkall{
    .van-checkbox {
      height: 35px;
      flex: 1;
      display: flex;
      justify-content: flex-end;
      .van-checkbox__icon {
        font-size: 18px;
      }
    }
  }
  .data-wrapper{
    .van-checkbox-group{
      flex:1;
    }
    .van-checkbox {
      height: 44px;
      display: flex;
      justify-content: flex-end;
      .van-checkbox__icon {
        font-size: 18px;
      }
    }

  }
</style>
<style lang='scss'scoped>
  .cascad-menu-box {
    background-color: #fff;
    .header {
      padding: 15px 15px 15px 5px;
      color: #000;
      // border-bottom: 1px solid #eee;
      img {
        width: 22px;
        height: 22px;
      }
      .title {
        font-size: 17px;
      }
      .addWard {
        color: #404040;
        font-size: 14px;
      }
    }
    .introduce-box{
      width: 300px;
      padding: 15px 30px 15px 10px;
      position: absolute;
      top: 60px;
      right: 10px;
      font-size: 16px;
      font-family: PingFangSC, PingFangSC-Medium;
      font-weight: 500;
      border-radius: 5px;
      background-color: #1C91FF;
      color:#fff;
      z-index: 100;
      .sanjiao{
        position: absolute;
        top: -12px;
        right: 20px;
        height: 0px;
        width: 0px;
        border-left: 10px solid transparent;
        border-bottom: 12px solid #1C91FF;
        border-right: 12px solid transparent;
      }
      .deptTips-close-box{
        padding: 10px;
        position: absolute;
        top: 50%;
        right: 0px;
        transform: translateY(-50%);
      }
      img{
        width: 18px;
        height: 18px;
      }
    }
    .tag-box {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .tag-item {
        padding: 0 10px;
        position: relative;
        height: 25px;
        margin-bottom: 10px;
        margin-right: 10px;
        background: #f5f9ff;
        border-radius: 4px;
        color: #26b4ff;
        font-size: 13px;
        .img-box{
          padding: 10px;
          position: absolute;
          top: -18px;
          right: -18px;
        }
        img{
          width: 16px;
          height: 16px;
          z-index: 99;
        }
      }
    }
    .search-box {
      position: relative;
      padding: 0px 12px;
      img {
        position: absolute;
        top: 66%;
        left: 24px;
        transform: translateY(-50%);
        width: 16px;
        height: 16px;
      }
      input {
        height: 30px;
        width: 100%;
        text-indent: 30px;
        opacity: 1;
        border: 1px solid #e5e5e5;
        border-radius: 31px;
        font-size: 14px;
      }
    }
    .tab-box {
      height: 48px;
      display: flex;
      justify-content: space-between;
      .ward-num {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        color: #26b4ff;
        padding-right: 10px;
      }
    }
    .tips-box {
      position: fixed;
      left: 0;
      bottom: 49px;
      width: 100%;
      height: 40px;
      padding: 0px 15px;
      background: #fdfbec;
      .tips-left {
        display: flex;
        align-items: center;
        color: #fc8a55;
        .dept-notice {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
      .dept-close {
        width: 17px;
        height: 17px;
      }
    }
    .button-box {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      display: flex;
      .btn {
        flex: 1;
        height: 50px;
        font-size: 18px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
      }
      .reset {
        background: #f2f2f2;
        color: #404040;
      }
      .confirm {
        color: #fff;
        background: #26b4ff;
      }
    }
  }
</style>
<style lang="scss" scoped>
  .cascad-menu {
    display: flex;
    position: absolute;
    bottom: 100px;
    width: 100%;
    overflow: hidden;
    text-align: center;
    color: #404040;
  }
  .left-menu {
    flex: 0 0 80px;
    // width: 80px;
    width: 100px;
    // background: #f3f5f7;
    background: #e5e5e5;
    font-size: 15px;
    .left-menu-container{
      width: 100px;
    }
    .left-item {
      height: 50px;
      width: 100%;
      border-bottom: 1px solid #fff;
      &.current {
        // background: #fff;
        background: #cae7fc;
      }
      .text {
        width: 100%;
      }
    }
  }
  .right-menu {
    flex: 1;
    background-color: #fff;
    font-size: 14px;
    .right-item {
      height: 100%;
      .title {
        display: flex;
        padding: 0 10px 0 15px;
        align-items: center;
        justify-content: space-between;
        height: 40px;
        background: #f2f2f2;
      }
      .item-checkall {
        flex: 1;
        position: relative;
        display: flex;
        align-items: center;
        .all-text{
          position: absolute;
          top: 48%;
          right: 20px;
          transform: translateY(-50%);
          font-size:14px;
          color:#999;
        }
      }
      .data-wrapper {
        height: 44px;
        padding: 0px 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #eee;
        text-align: left;
        .data{
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
</style>
